export function formatCapitalizeString(text: string) {
  return (
    text.charAt(0).toUpperCase() +
    text.replace(/[_]/g, " ").toLowerCase().slice(1)
  );
}
